import { useEffect, useState } from "react";
import AuthUser from "./AuthUser";
import toast, { Toaster } from "react-hot-toast";
import moment from "moment";
import TaskSkeleton from "./TaskSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFile } from "@fortawesome/free-solid-svg-icons";
import InvoiceModal from "./InvoiceModal";

export default function Tasksview() {
  const { http, user } = AuthUser();
  const [tasks, setTasks] = useState([]);
  const [date, setDate] = useState(null);
  const [remark, setRemark] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [departments, setdepartments] = useState([]);
  const [currentStatus, setCurrentStatus] = useState(null);
  const [loginUser, setloginUser] = useState(user.department_id);
  const [selectedDepartmentId, setselectedDepartmentId] = useState("");
  const [selectedStatus, setsselectedStatus] = useState("Pending");
  const [note, setNote] = useState("");
  const [noteTaskId, setNoteTaskId] = useState(null);
  const [showNoteModal, setShowNoteModal] = useState(false);
  const [showOtpModal, setShowOtpModal] = useState(false);
  const [otpTaskId, setOtpTaskId] = useState(null);
  const [otpData, setOtpData] = useState({
    start_otp: "",
    end_otp: ""
  });
  const [showInvoiceModal, setShowInvoiceModal] = useState(false);
  const [invoiceTaskId, setInvoiceTaskId] = useState(null);
  const [showSeatModal, setShowSeatModal] = useState(false);
  const [seatJcId, setSeatJcId] = useState(null);
  const [seatHqTaskId, setSeatHqTaskId] = useState(null);
  const [seatValue, setSeatValue] = useState("");
  const [seatLoading, setSeatLoading] = useState(false);

  useEffect(() => {
    fetchTaskDetails(selectedDepartmentId, selectedStatus);
  }, [selectedDepartmentId, selectedStatus]);

  const fetchTaskDetails = (seldepartment = "", selstatus = "") => {
    setIsLoading(true);
    let endpoint;
    if (user && user.department_id === 1) {
      endpoint = `/tasks?department=${seldepartment}&status=${selstatus}&user=${user.id}&login_user=${user.id}`;
    } else if (user) {
      endpoint = `/tasks?user=${user.id}&department=${seldepartment}&status=${selstatus}&login_user=${user.id}`;
    } else {
      setIsLoading(false);
      console.error("User is not defined or authenticated");
      return;
    }

    http
      .get(endpoint)
      .then((res) => {
        setIsLoading(false);
        if (Array.isArray(res.data.data)) {
          setTasks(res.data.data);
        } else {
          console.error("API response is not an array");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching tasks:", error);
      });

    http.get(`/departments?login_user=${user.id}`).then((res) => {
      setdepartments(res.data.data);
    });
  };
  const [showModal, setShowModal] = useState(false);
  const [showModalRevise, setShowModalRevise] = useState(false);
  const [ModalId, setModalId] = useState(false);
  const openModal = (taskId) => {
    setShowModal(true);
    setModalId(taskId);
  };

  const openModalRevise = (rmark, revisedate) => {
    setDate(revisedate);
    setRemark(rmark);
    setShowModalRevise(true);
  };

  const closeModal = () => {
    setShowModal(false);
    setShowModalRevise(false);
    setShowNoteModal(false);
    setShowOtpModal(false);
    setShowInvoiceModal(false);
    setShowSeatModal(false);
    setSeatJcId(null);
    setSeatHqTaskId(null);
    setSeatValue("");
  };

  const openSeatModal = (jcId, currentValue, hqTaskId = null) => {
    if (!jcId && !hqTaskId) {
      toast.error("No JC linked to this task");
      return;
    }
    setSeatJcId(jcId || null);
    setSeatHqTaskId(hqTaskId || null);
    setSeatValue(currentValue === "yes" || currentValue === "no" ? currentValue : "");
    setShowSeatModal(true);
  };

  const handleSeatSubmit = async (e) => {
    e.preventDefault();
    if (!seatJcId && !seatHqTaskId) {
      toast.error("No JC linked");
      return;
    }
    if (seatValue !== "yes" && seatValue !== "no") {
      toast.error("Please select Yes or No");
      return;
    }
    setSeatLoading(true);
    try {
      const targetId = seatJcId || seatHqTaskId;
      const body = {
        jc_seat_submitted: seatValue,
        task_id: seatHqTaskId || undefined,
      };
      try {
        await http.put(`/jc_seat_submitted/${targetId}`, body);
      } catch (firstErr) {
        // Retry via HQ task id if JC id lookup failed
        if (
          seatHqTaskId &&
          seatJcId &&
          seatHqTaskId !== seatJcId &&
          firstErr.response?.status === 404
        ) {
          await http.put(`/jc_seat_submitted/${seatHqTaskId}`, body);
        } else {
          throw firstErr;
        }
      }
      toast.success("JC seat submitted updated");
      closeModal();
      fetchTaskDetails(selectedDepartmentId, selectedStatus);
    } catch (error) {
      toast.error(error.response?.data?.message || "Update failed");
    } finally {
      setSeatLoading(false);
    }
  };

  const openInvoiceModal = (taskId) => {
    setInvoiceTaskId(taskId);
    setShowInvoiceModal(true);
  };

  const closeInvoiceModal = () => {
    setShowInvoiceModal(false);
    setInvoiceTaskId(null);
  };
  const handleChange = async (event) => {
    setselectedDepartmentId(event.target.value);
  };

  const handleChangeType = async (event) => {
    setsselectedStatus(event.target.value);
  };

  const statusUpdate = (e) => {
    setCurrentStatus(e.target.value);
  };

  const deleteTask = async (taskId) => {
    await http
      .delete(`/tasks/${taskId}`)
      .then((response) => {
        toast.success("Task Deleted successfully !");
        fetchTaskDetails(selectedDepartmentId, selectedStatus);
        //  setTasks(response.data.data);
      })
      .catch((err) => {
        console.error("Error deleting task", err);
      });
  };

  const handleSave = async (taskId) => {
    if (currentStatus === null || taskId === null) {
      toast.error("Please select proper status");
      return true;
    }
    try {
      const response = await http.put(
        `task_status_update?task_id=${taskId}&status=${encodeURIComponent(
          currentStatus
        )}`
      );
      toast.success("Task status updated successfully !");
      fetchTaskDetails(selectedDepartmentId, selectedStatus);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      toast.error("Please select proper item");
    }
  };

  const [formData, setFormData] = useState({
    revised_date: "",
    revised_remark: "",
  });
  const initialState = {
    revised_date: "",
    revised_remark: "",
  };

  const handleChangeModal = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Ensure formData.revised_date is a valid date format (you may need additional validation)
      const revisedDate = new Date(formData.revised_date);

      // Calculate the difference in days between current date and revised date
      const currentDate = new Date();
      const differenceInDays = Math.floor(
        (revisedDate - currentDate) / (24 * 60 * 60 * 1000)
      );

      if (differenceInDays >= 3) {
        toast.error(
          "Revised date should not be more than 3 days from the current day."
        );
        return; // Terminate the performance
      }

      if (formData.revised_remark == '') {
        toast.error(
          "Please add revise note"
        );
        return;
      }

      // Continue with the API call and other logic if the date is within the limit
      await http.put(`/revise/${ModalId}`, formData);
      toast.success("Revise date added successfully!");
      setFormData(initialState);
      fetchTaskDetails(selectedDepartmentId, selectedStatus);
      closeModal();
    } catch (error) {
      console.error("Error adding task:", error.response.data);
    }
  };

  const downloadFile = (filename) => {
    // Construct the URL to the file.
    const fileUrl = `http://3.6.125.26/api/storage/tasks/${filename}`;

    // Create a link element
    const link = document.createElement("a");
    link.href = fileUrl;
    link.setAttribute("download", ""); // the download attribute can be empty
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Remove the link from the DOM
  };

  const openNoteModal = (taskId) => {
    setNoteTaskId(taskId);
    setShowNoteModal(true);
  };

  const handleNoteSubmit = async (e) => {
    e.preventDefault();
    try {
      await http.post(`/save_remark`, { task_id: noteTaskId, remarks: note });
      toast.success("Note added successfully!");
      setNote("");
      closeModal();
    } catch (error) {
      console.error("Error adding note:", error);
    }
  };

  const [otpValidationStatus, setOtpValidationStatus] = useState({
    start_validated: false,
    end_validated: false
  });

  const openOtpModal = async (taskId, jcId) => {
    setOtpTaskId(jcId);
    setShowOtpModal(true);
    
    try {
      const response = await http.get(`get_otp_status/${jcId}`);
      setOtpValidationStatus({
        start_validated: response.data.start_otp_validated,
        end_validated: response.data.end_otp_validated
      });
    } catch (error) {
      console.error("Error fetching OTP status:", error);
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Error fetching OTP validation status");
      }
    }
  };

  const handleOtpChange = (e) => {
    setOtpData({
      ...otpData,
      [e.target.name]: e.target.value,
    });
  };

  const handleStartWork = async () => {
    if (!otpData.start_otp) {
      toast.error("Please enter Start OTP");
      return;
    }
    
    try {
      const response = await http.post(`/validate_start_otp`, { 
        task_id: otpTaskId, 
        start_otp: otpData.start_otp
      });
      
      if (response.data.message) {
        toast.success(response.data.message);
        setOtpData({ ...otpData, start_otp: "" });
        // Optionally refresh the task list to show updated status
        fetchTaskDetails(selectedDepartmentId, selectedStatus);
      }
    } catch (error) {
      console.error("Error validating start OTP:", error);
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Error validating start OTP");
      }
    }
  };

  const handleEndWork = async () => {
    if (!otpData.end_otp) {
      toast.error("Please enter End OTP");
      return;
    }
    
    try {
      const response = await http.post(`/validate_end_otp`, { 
        task_id: otpTaskId, 
        end_otp: otpData.end_otp
      });
      
      if (response.data.message) {
        toast.success(response.data.message);
        setOtpData({ start_otp: "", end_otp: "" });
        closeModal();
        // Refresh the task list to show updated status
        fetchTaskDetails(selectedDepartmentId, selectedStatus);
      }
    } catch (error) {
      console.error("Error validating end OTP:", error);
      if (error.response?.data?.error) {
        toast.error(error.response.data.error);
      } else {
        toast.error("Error validating end OTP");
      }
    }
  };



  return (
    <>
      <Toaster />
      {showNoteModal && (
        <div className="modal" tabindex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Note</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group mt-3">
                  <label>Note</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    value={note}
                    onChange={(e) => setNote(e.target.value)}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleNoteSubmit}
                >
                  Save Note
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showOtpModal && (
        <div className="modal" tabIndex="-1" style={{ display: "block" }}>
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header bg-gradient-primary">
                <h5 className="modal-title text-white fw-bold">
                  🔐 Branch-AMC OTP Details
                </h5>
                <button
                  type="button"
                  className="btn-close btn-close-white"
                  onClick={closeModal}
                ></button>
              </div>
                             <div className="modal-body p-4">
                 <div className="row">
                   <div className="col-md-6">
                     <div className="otp-card mb-3">
                       <div className="card border-success">
                         <div className="card-header bg-success text-white d-flex align-items-center justify-content-between">
                           <div className="d-flex align-items-center">
                             <span className="me-2">🟢</span>
                             <strong>Start Work</strong>
                           </div>
                           <small className="badge bg-light text-success">Step 1</small>
                         </div>
                         <div className="card-body">
                           <div className="form-group mb-3">
                             <label className="form-label fw-bold text-success">
                               Enter Start OTP:
                             </label>
                             <input
                               type="text"
                               name="start_otp"
                               className="form-control form-control-lg text-center fw-bold mb-3"
                               value={otpData.start_otp}
                               onChange={handleOtpChange}
                               placeholder="••••••"
                               maxLength="6"
                               style={{
                                 fontSize: '1.2rem',
                                 letterSpacing: '0.2rem',
                                 border: '2px solid #28a745',
                                 backgroundColor: '#f8fff9'
                               }}
                             />
                             {otpValidationStatus.start_validated ? (
                               <div className="text-success text-center">
                                 <span className="me-2">✅</span>
                                 <strong>Work Started - OTP Validated</strong>
                               </div>
                             ) : (
                               <>
                                 <button
                                   type="button"
                                   className="btn btn-success btn-lg w-100 fw-bold"
                                   onClick={handleStartWork}
                                   disabled={!otpData.start_otp}
                                   style={{
                                     borderRadius: '10px',
                                     boxShadow: '0 4px 15px rgba(40, 167, 69, 0.3)'
                                   }}
                                 >
                                   <span className="me-2">🚀</span>
                                   Start Work
                                 </button>
                                 <small className="text-muted d-block mt-2 text-center">
                                   Enter OTP and click to begin task
                                 </small>
                               </>
                             )}
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                   
                   <div className="col-md-6">
                     <div className="otp-card mb-3">
                       <div className="card border-danger">
                         <div className="card-header bg-danger text-white d-flex align-items-center justify-content-between">
                           <div className="d-flex align-items-center">
                             <span className="me-2">🔴</span>
                             <strong>End Work</strong>
                           </div>
                           <small className="badge bg-light text-danger">Step 2</small>
                         </div>
                         <div className="card-body">
                           <div className="form-group mb-3">
                             <label className="form-label fw-bold text-danger">
                               Enter End OTP:
                             </label>
                             <input
                               type="text"
                               name="end_otp"
                               className="form-control form-control-lg text-center fw-bold mb-3"
                               value={otpData.end_otp}
                               onChange={handleOtpChange}
                               placeholder="••••••"
                               maxLength="6"
                               style={{
                                 fontSize: '1.2rem',
                                 letterSpacing: '0.2rem',
                                 border: '2px solid #dc3545',
                                 backgroundColor: '#fff8f8'
                               }}
                             />
                             {otpValidationStatus.end_validated ? (
                               <div className="text-danger text-center">
                                 <span className="me-2">✅</span>
                                 <strong>Work Completed - OTP Validated</strong>
                               </div>
                             ) : (
                               <>
                                 <button
                                   type="button"
                                   className="btn btn-danger btn-lg w-100 fw-bold"
                                   onClick={handleEndWork}
                                   disabled={!otpData.end_otp || !otpValidationStatus.start_validated}
                                   style={{
                                     borderRadius: '10px',
                                     boxShadow: '0 4px 15px rgba(220, 53, 69, 0.3)'
                                   }}
                                 >
                                   <span className="me-2">✅</span>
                                   End Work
                                 </button>
                                 <small className="text-muted d-block mt-2 text-center">
                                   {!otpValidationStatus.start_validated ? 
                                     "Please validate Start OTP first" :
                                     "Enter OTP and click to complete task"
                                   }
                                 </small>
                               </>
                             )}
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
                 
                 <div className="alert alert-info d-flex align-items-center mt-3">
                   <span className="me-2">ℹ️</span>
                   <div>
                     <strong>Workflow:</strong> First click "Start Work" with Start OTP, then click "End Work" with End OTP when task is completed.
                   </div>
                 </div>
               </div>
               
               <div className="modal-footer bg-light">
                 <button
                   type="button"
                   className="btn btn-secondary btn-lg"
                   onClick={closeModal}
                   style={{ borderRadius: '10px' }}
                 >
                   <span className="me-1">❌</span> Close
                 </button>
               </div>
            </div>
          </div>
        </div>
      )}

      {showSeatModal && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  JC Seat Submitted {seatJcId ? `(JC-${seatJcId})` : ""}
                </h5>
                <button type="button" className="btn-close" onClick={closeModal}></button>
              </div>
              <form onSubmit={handleSeatSubmit}>
                <div className="modal-body">
                  <label className="form-label fw-semibold">
                    JC seat submitted?
                  </label>
                  <select
                    className="form-select"
                    value={seatValue}
                    onChange={(e) => setSeatValue(e.target.value)}
                    required
                  >
                    <option value="">Select</option>
                    <option value="yes">Yes</option>
                    <option value="no">No</option>
                  </select>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-secondary" onClick={closeModal}>
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary" disabled={seatLoading}>
                    {seatLoading ? "Saving..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}

      {showModal && (
        <form onSubmit={handleSubmit}>
          <div className="modal" tabindex="-1" style={{ display: "block" }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Revision Details</h5>
                  <button
                    type="button"
                    className="btn-close"
                    onClick={closeModal}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="form-group  mt-3">
                    <label>New Revision Date</label>
                    <input
                      name="revised_date"
                      className="form-control"
                      type="date"
                      onChange={handleChangeModal}
                    />
                  </div>

                  <div className="form-group mt-3">
                    <label>Revision Note</label>
                    <textarea
                      name="revised_remark"
                      className="form-control"
                      onChange={handleChangeModal}
                      rows="3"
                    />
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={closeModal}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Save changes
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
      )}

      {showModalRevise && (
        <div className="modal" tabindex="-1" style={{ display: "block" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Revision Details</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="form-group  mt-3">
                  <label>New Revision Date</label>
                  <input
                    name="revised_date"
                    className="form-control"
                    type="date"
                    value={date}
                  />
                </div>

                <div className="form-group mt-3">
                  <label>Revision Note</label>
                  <textarea
                    name="revised_remark"
                    className="form-control"
                    rows="3"
                    value={remark}
                  />
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="container mt-1">
        <div className="row mb-2">
          <div className="col-md-4">
            {user && user.department_id == 1 ? (
              <h1 className="mb-1">Your Tasks List</h1>
            ) : (
              <h1 className="mb-1">Your Tasks List</h1>
            )}
          </div>
          {user && user.department_id == 1 && (
            <div className="col-md-4 form-group text-end">
              <select onChange={handleChange} className="form-control mb-1">
                <option value="">Select Department</option>
                <option value="">All Department</option>
                {departments.map((depart) => (
                  <option key={depart.id} value={depart.id}>
                    {depart.name}
                  </option>
                ))}
              </select>
            </div>
          )}
          <div className="col-md-4 form-group text-end">
            <select onChange={handleChangeType} className="form-control">
              <option value="">Select Status</option>
              <option value="">All Status</option>
              <option value="Pending">Pending</option>
              <option value="Completed">Completed</option>
              <option value="Finished">Finished</option>
              <option value="Progress">Progress</option>
              <option value="Delayed">Delayed</option>
              <option value="Delayed Completed">Delayed Completed</option>
            </select>
          </div>
        </div>

        <div className="table-responsive" style={{overflowX: 'auto', maxWidth: '100%'}}>
          {isLoading ? (
            <TaskSkeleton />
          ) : (
            <table className="table table-striped table-hover">
              <thead className="table-primary sticky-top">
                <tr>
                  <th style={{width: '3%', whiteSpace: 'nowrap'}}>No</th>
                  <th style={{width: '4%', whiteSpace: 'nowrap'}}>ID</th>
                  <th style={{width: '8%', whiteSpace: 'nowrap'}} className="text-danger">Created</th>
                  <th style={{width: '20%'}}>Description</th>
                  <th style={{width: '8%', whiteSpace: 'nowrap'}}>Assign To</th>
                  <th style={{width: '8%', whiteSpace: 'nowrap'}}>Department</th>
                  <th style={{width: '8%', whiteSpace: 'nowrap'}}>Status</th>
                  <th style={{width: '7%', whiteSpace: 'nowrap'}}>JC Seat</th>
                  <th style={{width: '10%'}}>Additional Info</th>
                  <th style={{width: '7%', whiteSpace: 'nowrap'}}>Due Date</th>
                  <th style={{width: '3%', whiteSpace: 'nowrap'}}>ET</th>
                  <th style={{width: '3%', whiteSpace: 'nowrap'}}>W</th>
                  <th style={{width: '6%', whiteSpace: 'nowrap'}}>Priority</th>
                  <th style={{width: '7%', whiteSpace: 'nowrap'}}>Assign By</th>
                  <th style={{width: '15%', whiteSpace: 'nowrap'}}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {tasks.map((user, index) => (
                  <tr key={user.id}>
                    <td>{index + 1}</td>
                    <td className="fw-bold text-primary">T{user.id}</td>
                    <td className="small">
                      {moment(user.created_at).format("DD MMM,YY")}
                      <br />
                      <span className="text-muted">{moment(user.created_at).format("hh:mm A")}</span>
                    </td>
                    <td>
                      <div className="task-description">
                        <strong className="text-info">{user.jc_id ? "JC-" + user.jc_id : ""}</strong>
                        <div style={{whiteSpace: 'normal', wordBreak: 'break-word'}} className="description-text">
                          {user.description}
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className="assignee-cell">
                        <div className="text-uppercase fw-bold small text-truncate" style={{maxWidth: '100px'}}>
                          {user.assignee?.name} {user.assignee?.last_name}
                        </div>
                        {user.task_file && (
                          <FontAwesomeIcon
                            icon={faFile}
                            className="file-icon text-primary cursor-pointer"
                            onClick={() => downloadFile(user.task_file)}
                            title="Download File"
                          />
                        )}
                      </div>
                    </td>
                    <td>
                      <span className="badge bg-light text-dark border">
                        {user.department?.name}
                      </span>
                    </td>
                    <td>
                      <div className="status-cell">
                        {user.status === "Completed" && (
                          <span className="badge bg-success">Completed</span>
                        )}
                        {user.status === "Finished" && (
                          <span className="badge bg-primary">Finished</span>
                        )}
                        {user.status === "Pending" && (
                          <span className="badge bg-danger">Pending</span>
                        )}
                        {user.status === "Delayed" && (
                          <span className="badge bg-warning">Delayed</span>
                        )}
                        {user.status === "Delayed Completed" && (
                          <span className="badge bg-warning">Delayed Completed</span>
                        )}
                        {user.status === "Progress" && (
                          <span className="badge bg-secondary">Progress</span>
                        )}
                      </div>
                    </td>
                    <td className="text-center">
                      {user.jc_id ? (
                        user.jc_seat_submitted === "yes" ? (
                          <span className="badge bg-success">Yes</span>
                        ) : user.jc_seat_submitted === "no" ? (
                          <span className="badge bg-danger">No</span>
                        ) : (
                          <span className="badge bg-secondary">—</span>
                        )
                      ) : (
                        <span className="text-muted">—</span>
                      )}
                    </td>
                    <td>
                      <div className="text-truncate" style={{maxWidth: '130px'}} title={user.additional_info}>
                        {user.additional_info}
                      </div>
                    </td>
                    <td>
                      <div className="small">
                        {moment(user.target_date).format("DD MMM,YY")}
                        {/* Revise badge — uncomment to show again
                        {user.is_revised == 1 && (
                          <div className="mt-1">
                            <button
                              className="badge bg-danger border-0"
                              onClick={() =>
                                openModalRevise(
                                  user.revised_remark,
                                  user.revised_date
                                )
                              }
                              title="View Revision"
                            >
                              R
                            </button>
                          </div>
                        )}
                        */}
                      </div>
                    </td>
                    <td className="text-center">{user.est_time}</td>
                    <td className="text-center">{user.task_weightage}</td>
                    <td>
                      <span className={`badge ${
                        user.priority === 'High' ? 'bg-danger' :
                        user.priority === 'Medium' ? 'bg-warning' : 'bg-success'
                      }`}>
                        {user.priority}
                      </span>
                    </td>
                    <td className="text-uppercase fw-bold small">
                      {user.assigner?.name} {user.assigner?.last_name}
                    </td>
                    <td>
                      <div className="action-container">
                        {/* Status Update Row */}
                        <div className="status-update-row">
                          <select
                            onChange={statusUpdate}
                            className="form-select form-select-sm"
                          >
                            <option value="">Update Status</option>
                            <option value="Progress">Progress</option>
                            <option value="Finished">Finished</option>
                          </select>
                          <button
                            className="btn btn-sm btn-success ms-1"
                            onClick={() => handleSave(user.id)}
                            title="Save Status"
                          >
                            ✓
                          </button>
                        </div>
                        
                        {/* Compact Action Buttons */}
                        <div className="action-buttons-row">
                          <div className="d-flex align-items-center gap-1">
                            {/* Revise icon — uncomment to show again
                            {user.is_revised === 0 && (
                              <button
                                className="btn btn-xs btn-outline-primary compact-btn"
                                onClick={() => openModal(user.id)}
                                title="Revise Task"
                              >
                                📅
                              </button>
                            )}
                            */}
                            
                            {user.department?.name === "Branch-AMC" && (
                              <button
                                className="btn btn-xs btn-outline-warning compact-btn"
                                onClick={() => openOtpModal(user.id, user.jc_id)}
                                title="OTP Details"
                              >
                                🔐
                              </button>
                            )}

                            {user.jc_id && (
                              <button
                                className="btn btn-xs btn-outline-primary compact-btn"
                                onClick={() =>
                                  openSeatModal(
                                    user.jc_id,
                                    user.jc_seat_submitted,
                                    user.id
                                  )
                                }
                                title="JC Seat Submitted"
                              >
                                🪑
                              </button>
                            )}
                            
                            <button
                              className="btn btn-xs btn-outline-success compact-btn"
                              onClick={() => openInvoiceModal(user.id)}
                              title="Download Invoice"
                            >
                              📄
                            </button>
                            
                            <button
                              className="btn btn-xs btn-outline-info compact-btn"
                              onClick={() => openNoteModal(user.id)}
                              title="Add Note"
                            >
                              📝
                            </button>
                            
                            {loginUser === 1 && (
                              <button
                                className="btn btn-xs btn-outline-danger compact-btn"
                                onClick={() => {
                                  if (
                                    window.confirm(
                                      "Are you sure you want to delete this task?"
                                    )
                                  ) {
                                    deleteTask(user.id);
                                  }
                                }}
                                title="Delete Task"
                              >
                                🗑️
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      <style jsx>{`
        .table-responsive {
          border-radius: 10px;
          box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
          overflow: visible;
          -webkit-overflow-scrolling: touch;
          position: relative;
          z-index: 1;
          margin: 0 auto;
          width: 100%;
        }
        
        .table {
          width: 100%;
          table-layout: fixed;
        }
        
        .table tbody tr {
          position: relative;
          z-index: 1;
        }
        
        .table tbody tr td {
          position: relative;
          z-index: 1;
        }
        
        .action-container {
          min-width: 160px;
          width: 100%;
          position: relative !important;
          z-index: 9998 !important;
        }
        
        .status-update-row {
          display: flex;
          align-items: center;
          gap: 4px;
          margin-bottom: 6px;
        }
        
        .status-update-row .form-select {
          font-size: 0.875rem;
          flex: 1;
        }
        
        .dropdown-toggle {
          font-size: 0.875rem;
          padding: 0.375rem 0.75rem;
          border-radius: 6px;
          transition: all 0.2s ease;
        }
        
        .dropdown-toggle {
          z-index: 9996 !important;
          position: relative !important;
        }
        
        .dropdown-toggle:hover {
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(0,0,0,0.1);
          z-index: 9996 !important;
          position: relative !important;
        }
        
        .dropdown-menu {
          font-size: 0.875rem;
          border-radius: 8px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.15);
          border: 1px solid rgba(0,0,0,0.1);
          z-index: 9999 !important;
          position: absolute !important;
          background-color: #fff !important;
        }
        
        .dropdown-item {
          padding: 0.5rem 1rem;
          transition: all 0.2s ease;
        }
        
        .dropdown-item:hover {
          background-color: rgba(13, 110, 253, 0.1);
          transform: translateX(2px);
        }
        
        .dropdown-item.text-danger:hover {
          background-color: rgba(220, 53, 69, 0.1);
        }
        
        .compact-btn {
          padding: 2px 4px !important;
          font-size: 0.75rem !important;
          line-height: 1 !important;
          border-radius: 3px !important;
          min-width: 22px !important;
          height: 22px !important;
          transition: all 0.2s ease;
          border-width: 1px !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
        
        .compact-btn:hover {
          transform: scale(1.1);
          box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        
        .action-buttons-row {
          margin-top: 4px;
        }
        
        .action-buttons-row .d-flex {
          flex-wrap: nowrap;
          justify-content: flex-start;
          gap: 4px !important;
        }
        
        .table-responsive {
          position: relative;
          z-index: 1;
        }
        
        .dropdown-menu.show {
          z-index: 10001 !important;
          animation: dropdownFadeIn 0.15s ease-in-out;
          position: absolute !important;
        }
        
        @keyframes dropdownFadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        /* Bootstrap dropdown override */
        .btn-group .dropdown-menu,
        .dropdown .dropdown-menu {
          z-index: 10002 !important;
          position: absolute !important;
          will-change: transform !important;
        }
        
        .btn-group.show .dropdown-menu,
        .dropdown.show .dropdown-menu {
          z-index: 10003 !important;
          display: block !important;
        }
        
        .assignee-cell {
          display: flex;
          align-items: center;
          gap: 6px;
          min-width: 120px;
        }
        
        .file-icon {
          font-size: 0.8rem;
          flex-shrink: 0;
        }
        
        .status-cell {
          display: flex;
          align-items: center;
          justify-content: center;
        }

        @media (max-width: 768px) {
          .table th, .table td {
            padding: 0.5rem 0.25rem;
            vertical-align: middle;
          }
          
          .action-container {
            min-width: 140px;
          }
          
          .dropdown-toggle {
            font-size: 0.8rem;
            padding: 0.25rem 0.5rem;
          }
          
          .dropdown-menu {
            font-size: 0.8rem;
            min-width: 150px;
          }
          
          .task-description {
            max-width: 180px;
          }
          
          .assignee-cell {
            min-width: 110px;
          }
        }
        
        @media (max-width: 576px) {
          .table th, .table td {
            padding: 0.4rem 0.2rem;
          }
          
          .action-container {
            min-width: 120px;
          }
          
          .dropdown-toggle {
            font-size: 0.75rem;
            padding: 0.2rem 0.4rem;
          }
          
          .dropdown-menu {
            font-size: 0.75rem;
            min-width: 130px;
          }
          
          .task-description {
            max-width: 150px;
          }
        }

        .table {
          margin-bottom: 0;
        }

        .table thead th {
          border-bottom: 2px solid #dee2e6;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 0.85rem;
          letter-spacing: 0.5px;
        }

        .table tbody tr:hover {
          background-color: rgba(0, 123, 255, 0.05);
          transform: scale(1.01);
          transition: all 0.2s ease;
        }

        .cursor-pointer {
          cursor: pointer;
        }

        .cursor-pointer:hover {
          transform: scale(1.1);
          transition: all 0.2s ease;
        }

        .task-description {
          width: 100%;
        }
        
        .description-text {
          padding: 8px 0;
          line-height: 1.4;
        }

        .badge {
          font-size: 0.75rem;
          padding: 0.35em 0.65em;
        }

        .btn-sm {
          padding: 0.25rem 0.5rem;
          font-size: 0.75rem;
          border-radius: 0.375rem;
        }

        .modal-content {
          border: none;
          border-radius: 15px;
          box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
        }

        .modal-header {
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 15px 15px 0 0;
        }

        .modal-footer {
          border-top: 1px solid rgba(0, 0, 0, 0.1);
          border-radius: 0 0 15px 15px;
        }

        .bg-gradient-primary {
          background: linear-gradient(135deg, #007bff 0%, #0056b3 100%);
        }

        .otp-card .card {
          border-radius: 12px;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }

        .otp-card .card:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        }

        .otp-card .card-header {
          border-radius: 12px 12px 0 0;
          font-weight: 600;
        }

        .otp-card input:focus {
          box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
          transform: scale(1.02);
        }

        .otp-card .btn:hover {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2) !important;
        }

        .otp-card .btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
          transform: none !important;
        }

        .otp-card .btn:disabled:hover {
          transform: none !important;
          box-shadow: none !important;
        }

        .badge.bg-light {
          font-size: 0.7rem;
          padding: 0.3em 0.6em;
        }

        .alert {
          border-radius: 10px;
          border: none;
        }

        .alert-info {
          background: linear-gradient(135deg, #d1ecf1 0%, #bee5eb 100%);
          color: #0c5460;
        }

        .sticky-top {
          position: sticky;
          top: 0;
          z-index: 10;
        }

        @media (max-width: 768px) {
          .table-responsive {
            font-size: 0.85rem;
          }
          
          .btn-sm {
            padding: 0.2rem 0.4rem;
            font-size: 0.7rem;
          }
          
          .badge {
            font-size: 0.65rem;
            padding: 0.25em 0.5em;
          }
        }
      `}</style>
    </>
  );
}
